import React from 'react';
import Button from '../../../components/ui/Button';

const QuickActions = ({ onAction }) => {
  const actions = [
    
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
      {actions?.map((action) => (
        <Button
          key={action?.id}
          variant={action?.variant}
          iconName={action?.icon}
          iconPosition="left"
          fullWidth
          onClick={() => onAction && onAction(action?.id)}
          className="justify-start"
        >
          {action?.label}
        </Button>
      ))}
    </div>
  );
};

export default QuickActions;